<cloudlabs-skip-to-main-content *ngIf="!isMylearning" [mainDiv]="'main-landmark'"></cloudlabs-skip-to-main-content>
<ng-container *ngIf="lab">
  <cloudlabs-refined-header *ngIf="environment.appType !== 'trial'"
    [customLogo]="lab.PartnerheaderLogo ? lab.PartnerheaderLogo : lab?.PartnerLogo" [lab]="lab"
    [labLaunchedState]="updatedLabStatus" [menu]="isHideMenu" [showTitle]="!lab?.BannerImage || isMylearning"
    [counter]="counter" [actionList]="actionList" (actionClickEvent)="actionClickEvent($event)"
    [attendeeEndDate]="endDateData" [operationModes]="operationMode" [modeOfOperation]="operationMode" [isMylearning]="isMylearning" [showIPOption]="showIPOption"
    [showDelete]="showDelete">
  </cloudlabs-refined-header>
  <ng-container *ngIf="!isMylearning">
    <!-- <cloudlabs-header *ngIf="enableHeader && environment.appType !== 'trial'" [lab]="lab"
      [customLogo]="lab.PartnerheaderLogo ? lab.PartnerheaderLogo : lab.PartnerLogo" [menu]="isHideMenu"
      (languageChangeEvent)="languageChanged($event)"></cloudlabs-header> -->

    <div *ngIf="[labModes.LAB, labModes.ANONYMOUS].includes(mode)" [class.sideNavBar]="isSidenav === true"
      [ngClass]="{'trial-header-space': environment.appType === 'trial'}">
      <nav class="fixed-top one" role="navigation" [attr.inert]='!isSidenav ? true: null' aria-label="Table of content">
        <div class="space-class">
          <ul class="nav nav-pills mb-5" [attr.aria-hidden]="isSidenav? false: true" id="pills-tab" role="tablist">
            <li class="nav-item" role="presentation">
              <a role="tab" [attr.aria-selected]="overViewSelected" [attr.tabindex]="isSidenav ? '0' : '-1'"
                class="bg-Hover" id="pills-overview-tab" data-toggle="pill" href="#pills-overview"
                aria-controls="pills-overview" (click)="setView('OVERVIEW')">{{ "OVERVIEW" | translate }}</a>
            </li>
            <li class="nav-item" *ngIf="!hidevideo" role="presentation">
              <a role="tab" [attr.aria-selected]="videoViewSelected" [attr.tabindex]="isSidenav ? '0' : '-1'"
                class="bg-Hover" id="pills-video-tab" data-toggle="pill" href="#pills-video" aria-controls="pills-video"
                (click)="setView('VIDEO')">{{"VIDEO" | translate}}</a>
            </li>
            <li class="nav-item" role="presentation">
              <a role="tab" [attr.aria-selected]="labViewSelected" [attr.tabindex]="isSidenav ? '0' : '-1'"
                class="bg-Hover active" id="pills-lab-tab" data-toggle="pill" href="#pills-lab"
                aria-controls="pills-lab" (click)="setView('LAB')">{{"LAB" | translate}}</a>
            </li>
          </ul>
          <teams-button [attr.tabindex]="isSidenav ? '0' : '-1'" [ariaLabel]="'Collapse'"
            [attr.inert]="!isSidenav? true : null" [ariaDescribedby]="'sideBarDescription'"
            [classList]="'btn closeSidenav'" (buttonClick)="closeSidenav()" style="width:95%; text-align:right;">
            <span aria-hidden="true">&#171;</span>
            {{"COLLAPSE" | translate}}</teams-button>
        </div>
      </nav>
      <div role="main">
        <div class="tab-content two">
          <div class="col-md-12" *ngIf=" environment?.appType === 'lab'"
            [ngClass]="{'main-title': lab?.BannerImage, 'main-title-no-banner': !lab?.BannerImage}"
            [ngStyle]="{'background-image': lab?.BannerImage ? 'url(\''+ lab?.BannerImage +'\'' : ''}">
            <div *ngIf="lab?.BannerImage">
              <h1>{{lab?.DisplayName || lab?.Title}}</h1>
            </div>
          </div>
        </div>
        <div style="display: none" id="sideBarDescription">
          <p *ngIf="isSidenav">{{'SIDEBAR_OPEN_MESSAGE' | translate}}</p>
          <p *ngIf="!isSidenav">{{'SIDEBAR_CLOSED_MESSAGE' | translate}}</p>
        </div>

        <div class="container-fluid">
          <div class="two row px-5 pt-1">

            <div class="col-md-12">
              <div class="tab-content pb-3" id="pills-tabContent">
                <div class="tab-pane fade show" id="pills-overview" role="tabpanel"
                  aria-labelledby="pills-overview-tab">
                  <cloudlabs-lab-overview [lab]="lab"></cloudlabs-lab-overview>
                </div>
                <div *ngIf="lab.LinkToVideo" class="tab-pane fade show" id="pills-video" role="tabpanel"
                  aria-labelledby="pills-video-tab">
                  <cloudlabs-lab-video [lab]="lab" [view]="currentView"></cloudlabs-lab-video>
                </div>
                <div class="tab-pane fade show active" id="pills-lab" role="tabpanel" aria-labelledby="pills-lab-tab">
                  <cloudlabs-lab [lab]="lab" [voucherCode]="this.voucherCode" [mode]="mode"
                    (setCounter)="setCounter($event)" (menuHide)="isCompleteLab($event)" [actionEvent]="actionEvent"
                    [operationMode]="operationMode" (labStatus)="updateOperationMode($event)"
                    (labDeployedStatus)="updateLabStatus($event)" (extendLabAction)="extendLabAction($event)"
                    (setEndDate)="setEndDate($event)">
                  </cloudlabs-lab>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <cloudlabs-footer *ngIf="enableFooter && environment.appType !== 'trial'" class="appfooter" [labData]="lab">
    </cloudlabs-footer>
  </ng-container>
  <cloudlabs-lab *ngIf="isMylearning" [lab]="lab" [voucherCode]="this.voucherCode" [mode]="mode"
    (setCounter)="setCounter($event)" (menuHide)="isCompleteLab($event)" [operationMode]="operationMode"
    [actionEvent]="actionEvent" (labStatus)="updateOperationMode($event)" (labDeployedStatus)="updateLabStatus($event)"
    (extendLabAction)="extendLabAction($event)" (setEndDate)="setEndDate($event)">
  </cloudlabs-lab>
</ng-container>

<ng-container *ngIf="showIPpopup">
  <cloudlabs-dialoge-prompt appTrapFocus appAutoFocusModal appRefocusPreviousEl [popupWidth]="'55vw'"
    [baseZIndex]="9999902" [isDialog]="showIPpopup" (popupResponse)="resetRecords()">
    <div header class="subheading">
      <b>{{ 'ADD_IPV4_ADDRESS' | translate }}</b>
    </div>
    <div content class="">
      <div class="container  ipaddress-popup" [ngClass]="environment?.appType === 'lab'? 'mt-2': 'mt-3'">
        <div class="mb-3 d-flex">
          <a class="ts-text-primary d-flex align-items-center" href="javascript:void(0)" (click)="addRecord(true)"
            tabindex="0">
            <i class="fas fa-plus ts-text-primary text-primary mr-2"></i>
            {{"ADD_CLIENT_IPV4_ADDRESS" | translate}} ({{ clientIP }})
          </a>
          <a class="ts-text-primary d-flex align-items-center ml-5" href="javascript:void(0)" (click)="addRecord(false)"
            tabindex="0">
            <i class="fas fa-plus ts-text-primary text-primary mr-2"></i>
            {{"ADD_IPV4_RULE" | translate}}
          </a>
        </div>

        <div class="ip-note-section" *ngIf="records.length >= 5">
          <div class="icon-sec">
            <i class="fas fa-info-circle text-primary "></i>&nbsp;&nbsp;
          </div>
          <div class="" translate="IPV4_ADDRESS_LIMIT"></div>
        </div>

        <div class="row fw-bold pt-3 mb-2">
          <div class="col-5 font-weight-bold">{{"RULE_NAME" | translate}}</div>
          <div class="col-5 font-weight-bold">{{"IPV4_ADDRESS" | translate}}</div>
        </div>

        <div *ngIf="records.length === 0" class="text-center text-muted mt-3">
          <p>{{"NO_RECORDS_FOUND" | translate}}</p>
        </div>

        <form [formGroup]="form">
          <div formArrayName="records">
            <div *ngFor="let record of records.controls; let i = index" [formGroupName]="i" class="row mb-2">

              <div class="col-5">
                <teams-input [classList]="'form-control'" formControlName="ruleName"
                  [ngClassList]="record.get('ruleName')?.invalid && record.get('ruleName')?.touched ? 'is-invalid': ''"
                  [ngClass]="{ 'is-invalid ': record.get('ruleName')?.invalid && record.get('ruleName')?.touched }"
                  [placeholder]="'RULE_NAME' | translate"></teams-input>

                <div *ngIf="record.get('ruleName')?.invalid && record.get('ruleName')?.touched" class="text-danger small">
                    <span class="d-block" *ngIf="record.get('ruleName')?.errors?.required"> {{"MESSAGE_THIS_FIELD_REQUIRED" | translate}} </span>
                    <span class="d-block" *ngIf="record.get('ruleName')?.errors?.minlength"> {{'MIN_LENGTH_FIELD' | translate}} {{ruleNameMinLength}} </span>
                    <span class="d-block" *ngIf="record.get('ruleName')?.errors?.maxlength"> {{'MAX_LENGTH_FIELD' | translate}} {{ruleNameLength}} </span>
                    <span class="d-block" *ngIf="record.get('ruleName')?.errors?.pattern"> {{"ERROR_VALIDATION_MESSAGE" | translate}} </span>
                    <span class="d-block" *ngIf="record.get('ruleName')?.errors?.nonUnique"> {{"RULE_NAME_UNIQUE_MESSAGE" | translate}} </span>
                </div>
              </div>

              <div class="col-5">
                <teams-input [classList]="'form-control'" formControlName="ipAddress"
                  [ngClassList]="record.get('ipAddress')?.invalid && record.get('ipAddress')?.touched ? 'is-invalid': ''"
                  [ngClass]="{ 'is-invalid ': record.get('ipAddress')?.invalid && record.get('ipAddress')?.touched }"
                  [placeholder]="'IPV4_ADDRESS' | translate"></teams-input>
                <div *ngIf="record.get('ipAddress')?.invalid && record.get('ipAddress')?.touched"
                  class="invalid-feedback">
                  <span class="d-block" *ngIf="record.get('ipAddress')?.errors?.required">
                    {{ "MESSAGE_THIS_FIELD_REQUIRED" | translate }}
                  </span>
                  <span class="d-block" *ngIf="record.get('ipAddress')?.errors?.invalidIp">
                    {{"INVALID_IPV4_ADDRESS" | translate}}
                  </span>
                  <span class="d-block" *ngIf="record.get('ipAddress')?.errors?.nonUnique"> {{"IPV4_ADDRESS_UNIQUE" | translate}} </span>
                </div>
              </div>

              <div class="col-2 d-flex align-items-center" *ngIf="records.length > 1">
                <a href="javascript:void(0)" (click)="deleteRecord(i)" tabindex="0" [title]="'DELETE_IPV4_ADDRESS' | translate">
                  <i class="fas fa-trash-alt text-danger"></i>
                </a>
              </div>
            </div>
          </div>
        </form>
      </div>

    </div>
    <div footer class="col-md-12 mt-3">
      <teams-button [classList]="'btn btn-danger modal-close-button ts-btn-fluent-red'" [title]="'CANCEL' | translate"
        (click)="resetRecords()">
      </teams-button>
      <teams-button [classList]="'btn ts-btn-fluent-primary modal-ok-button'" (buttonClick)="saveIPAdress()" [title]="'SAVE' | translate"
        [index]="'ipSave'" [processingTitle]="btnLoadingService.getButtonText()" [showLoading]="btnLoadingService.getLoding()">
        </teams-button>
    </div>
  </cloudlabs-dialoge-prompt>
</ng-container>